<template>
  <div class="dass-modal-exchange-value">
    <dass-dialog
      v-if="is_modal_open"
      title=" "        
      size="large"
      ref="ModalExchangeValue"
      @close="cancelForm"
    >
      <template #content>
        <div class="dass-title">
            <h3>{{ this.$t('dass.cancelPurchaseVoucher') }} </h3>
        </div>          
          <div class="dass-container-group">
            <div class="dass-icon-label">
              <dass-icon class="checkbox-icon" style="margin-right: 1%" :class="brand.class_name || ''" token="icon-notification-priority_high" size="20" />
              <label class="items-checkbox" v-html="getGeneralSettings?.SCO_MSG_ESTORNO"></label>
            </div>
            <div v-if="!hasRefundableBalance" class="dass-no-balance-message">
              <p>{{ $t('dass.noBalanceToRefund') }}</p>
            </div>
            <div class="dass-balance-available" v-if="getBalance(paymentType.Cartao_de_credito) > 0">
              <span>{{ $t('dass.balancesAvailable') }} </span>
              <b>{{  $filters.toMoney(getBalance(paymentType.Cartao_de_credito)) }}</b>
              <div class="dass-input-purchase-container">
                <dass-input-text
                  type="tel"
                  id="dass-input-purchase"
                  class="dass-input-credit-card"
                  v-money="moneyMask"
                  v-model="creditCardValue"     
                  :label="$t('dass.creditCard')"
                  @blur="validateValueWithBalance(paymentType.Cartao_de_credito)"
                  />
                  <dass-button
                  :id="`dass-button-call-purchase-${this.brandName}`"
                  class="dass-button-call-purchase"
                  :class="this.isSafari ? `dass-button-tertiary-${this.brandName}` : ''"
                  variant="tertiary"
                  type="button"
                  :disabled="!isValidValue(paymentType.Cartao_de_credito)"
                  @click="returnValue(paymentType.Cartao_de_credito)"
                >
                  {{ $t('dass.reverse') }}
                </dass-button>
              </div>
              <small v-if="creditValueAboveBalance">{{ $t('dass.valueAboveBalance') }}</small>
            </div>
            
            <div class="dass-balance-available" v-if="getBalance(paymentType.Pix) > 0">
              <span>{{ $t('dass.balancesAvailable') }}</span>
              <b>{{   $filters.toMoney(getBalance(paymentType.Pix)) }}</b>
              <div class="dass-input-purchase-container">
                <dass-input-text
                  type="tel"
                  id="dass-input-purchase"
                  v-money="moneyMask"
                  v-model="pixValue" 
                  :label="$t('dass.pix')"
                  @blur="validateValueWithBalance(paymentType.Pix)"
                  />
                  <dass-button
                  :id="`dass-button-call-purchase-${this.brandName}`"
                  class="dass-button-call-purchase"
                  :class="this.isSafari ? `dass-button-tertiary-${this.brandName}` : ''"
                  variant="tertiary"
                  type="button"
                  :disabled="!isValidValue(paymentType.Pix)"
                  @click="returnValue(paymentType.Pix)"
                >
                  {{ $t('dass.reverse') }}
                </dass-button>
              </div>
              <small v-if="pixValueAboveBalance">{{ $t('dass.valueAboveBalance') }}</small>
            </div>
          </div>
          <div class="dass-actions">
            <dass-button :id="`dass-button-call-purchase-${this.brandName}`" :class="this.isSafari ? `dass-button-primary-${this.brandName} dass-buttons-wallet` : 'dass-buttons-wallet'" @click="cancelForm" type="button" variant="primary">
              {{ $t('dass.cancelar') }}
            </dass-button>              
          </div>          
      </template>
    </dass-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { useIsSafari } from '@/composables/useIsSafari'
import { moneyMask } from '@/helpers/globalfilters/defaultMoneyMask'
const paymentType = {
  Cartao_de_credito: ['6'],  
  Pix: ['11', '15', '17']  // 11 = Pix, 15 = Pix Parcelado, 17 = Pix Pagseguro
}

export default {
  name: 'ModalExchangeValue',
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    moneyMask,
    paymentType, 
    pixValue: '',
    creditCardValue: '', 
    isLoading: false,
    pixValueAboveBalance: false,
    creditValueAboveBalance: false
  }), 
  computed: {   
    ...mapGetters('brand', { brand: 'getBrand' }),
    ...mapGetters('wallet', ['getWalletHistoric']),
    ...mapGetters('generalSettings', ['getGeneralSettings']), 
    is_modal_open() {      
      return this.showModal
    },
    hasRefundableBalance() {
      return this.getBalance(this.paymentType.Cartao_de_credito) > 0 || 
             this.getBalance(this.paymentType.Pix) > 0;
    },      
  },
  setup() {
    const { isSafari, brandName } = useIsSafari()
    
    return {      
      isSafari,
      brandName
    }     
  },
  methods: {
    ...mapActions('wallet', ['refundGiftCard', 'sumWalletTransactions', 'listWalletHistoric', 'listDiscountCoupons']),  
    ...mapActions('toasts', ['showToast']),
    
    cancelForm: function () {
      this.$emit('closeModal')
    },    
    
    isValidValue(types) {
      const value = types === this.paymentType.Pix ? this.pixValue : this.creditCardValue;
      const formattedValue = Number(this.$filters.fromMoney(value));
      const balance = Number(this.getBalance(types));
      return formattedValue > 0 && formattedValue <= balance;
    },
    
    async returnValue(types) {      
      let dataToRequest = this.getWalletHistoric.find((item) => types.includes(item?.TIP_PGTO_ORIG?.toString()))
      if (!dataToRequest || this.isLoading) return
      
      this.isLoading = true
      try {
        if (types === this.paymentType.Pix) {
          const pixValueFormated = this.$filters.fromMoney(this.pixValue)
          if(parseFloat(pixValueFormated).toFixed(2) <= 0) {
            this.isLoading = false
            return
          }
          await this.refundGiftCard({
            con_id: dataToRequest?.CON_ID,                       
            mar_id: dataToRequest?.MAR_ID,          
            tipo_pag: dataToRequest?.TIP_PGTO_ORIG, 
            vlr_estorno: Number(pixValueFormated),
            tipo_vale: 'S'
          })            
          this.refundSucess(dataToRequest.CON_ID)
          
        } else if (types === this.paymentType.Cartao_de_credito) {
          const creditCardValueFormated = this.$filters.fromMoney(this.creditCardValue)                       
          if(parseFloat(creditCardValueFormated).toFixed(2) <= 0) {
            this.isLoading = false
            return
          }
          await this.refundGiftCard({
            con_id: dataToRequest?.CON_ID,                       
            mar_id: dataToRequest?.MAR_ID,          
            tipo_pag: dataToRequest?.TIP_PGTO_ORIG,
            vlr_estorno: Number(creditCardValueFormated),
            tipo_vale: 'S' 
          })            
          this.refundSucess(dataToRequest.CON_ID)
        } else {
          this.isLoading = false
        }
      } catch (error) {
        this.isLoading = false        
      } 
    },    
    
    async refundSucess(con_id) {
      this.$ShowAlert({
        variant: 'success',
        message: this.$t('dass.successGeneratedRefund')        
      })   
      await Promise.all([        
        this.sumWalletTransactions({con_id: con_id}),
        this.listWalletHistoric({con_id: con_id }),
        this.listDiscountCoupons({con_id: con_id})
      ]).catch((error) => {        
        this.showToast({
          variant: 'error',
          message: error
        })
      })   
      this.pixValue = ''
      this.creditCardValue = '' 
      this.$emit('closeModal')      
    },
    
    validateValueWithBalance(types) {         
      if (types === this.paymentType.Pix) {
        const pixValueFormated = Number(this.$filters.fromMoney(this.pixValue));
        const balance = Number(this.getBalance(this.paymentType.Pix));
        if (pixValueFormated > balance) {
          this.pixValue = this.getBalance(this.paymentType.Pix);
          this.pixValueAboveBalance = true;
          setTimeout(() => {
            this.pixValueAboveBalance = false;
          }, 5000);
        }
      } else if (types === this.paymentType.Cartao_de_credito) {
        const creditCardValueFormated = Number(this.$filters.fromMoney(this.creditCardValue));
        const creditCardBalance = Number(this.getBalance(this.paymentType.Cartao_de_credito));
       
        if (creditCardValueFormated > creditCardBalance) {
          this.creditCardValue = this.getBalance(this.paymentType.Cartao_de_credito);
          this.creditValueAboveBalance = true;
          setTimeout(() => {
            this.creditValueAboveBalance = false;
          }, 5000);
        }
      }
    },
    
    getBalance(types) {      
      const itemsOfType = this.getWalletHistoric.filter((item) => 
        types.includes(item?.TIP_PGTO_ORIG?.toString())
      );

      if (!itemsOfType || itemsOfType.length === 0) return 0;

      itemsOfType.sort((a, b) => {        
        const parseDate = (dataStr) => {
          if (!dataStr) return 0;
          const [data, hora] = dataStr.split(' ');
          const [dia, mes, ano] = data.split('/');
          return new Date(`${ano}-${mes}-${dia}T${hora}`).getTime();
        };

        const timeA = parseDate(a.MOV_DATA);
        const timeB = parseDate(b.MOV_DATA);

        if (timeA !== timeB) {
          return timeA - timeB; 
        }
        if (a.TRANS_OPER !== b.TRANS_OPER) {
          return a.TRANS_OPER === 'Credit' ? -1 : 1;
        }

        
        if (a.TRANS_OPER === 'Debit') {          
          return b.SALDO_TOTAL - a.SALDO_TOTAL; 
        } else {          
          return a.SALDO_TOTAL - b.SALDO_TOTAL; 
        }
      });
      
      const mostRecentItem = itemsOfType[itemsOfType.length - 1];

      return mostRecentItem?.SALDO_TIPO_PGTO?.toFixed(2) || 0;
    },
    
    formSubmit: async function () {
      this.$refs.ModalExchangeValue.close()
      this.toogleModalCode(true)
    },
  },
}
</script>
  
<style lang="scss" scoped>
.dass-modal-exchange-value {    
    .dass-dialog--contents {      
      padding: 5%;
      @media(max-width: 485px) {
        padding-left: 1%;
        padding-right: 1%;
        margin-left: 1%;
        margin-right: 1%;
      }
    }
    .dass-title {
      text-align: center;
      padding-bottom: var(--space);
    }    
    label {
      font-weight: bold;      
    }
    .items-checkbox {
      font-size: 1rem;
    }
  
    .footer {
      margin-top: var(--space__1-5x);
      display: flex;
      justify-content: space-between;
      .dass-button__primary {
        width: 250px;
      }
      .dass-button__tertiary {
        width: 250px;
      }      
    }  
     
  }
  .dass-actions {
    display: flex;
    justify-content: center;
    margin-top: 3rem;
  }
  
  .dass-container-group {
    display: flex;
    flex-direction: column;   
    margin-bottom: 5%;
    gap: 5px;
    .dass-no-balance-message {
      text-align: center;
      padding: var(--space__2x) var(--space);
      background-color: #f8f9fa; 
      border-radius: 8px;
      margin-top: var(--space);    
    p {
      text-transform: none !important;
      color: #666; 
      font-size: 1rem;
      margin: 0;
    }
  }
  }
  .dass-icon-label {
    text-align: center;
    margin-bottom: var(--space);
  }
  .dass-container-group .dass-input-text {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
  .theme-umbro {
    .dass-dialog--control {
      background-color: var(--theme-white) !important;
      color: var(--theme-black) !important;
    }
    .dass-link {
      outline: none !important;
      color: var(--theme-white) !important;
    }
    .dass-button__tertiary {
      color: var(--theme-white) !important;
      text-decoration: none !important;
    }
    label {
      color: var(--theme-black);
      background-color: transparent;
    }
    .dass-button__primary {
      background-color: var(--theme-white) !important;
      color: var(--theme-color) !important;
      transition: background-color 0.3s ease;
      &:hover {
        background-color: var(--theme-black) !important;
        color: var(--theme-white) !important;
      }
    }
  }
  
    .umbro {
      border: 2px solid var(--theme-white);
    }
    .fila {
      border: 2px solid #758396;
    }
    .new_balance {
      border: 2px solid #E5788B;
    }
    .custom-checkbox::after {
      content: "";
      display: none;
      width: 10px;
      height: 5px;
      transform: rotate(-45deg);
      position: relative;
    }
    .umbro::after {
      border-left: 2.5px solid var(--theme-color);
      border-bottom: 2.5px solid var(--theme-color);
    }
    .fila::after {
      border-left: 2.5px solid var(--theme-white);
      border-bottom: 2.5px solid var(--theme-white);
    }
    .new_balance::after {
      border-left: 2.5px solid var(--theme-white);
      border-bottom: 2.5px solid var(--theme-white);
    }
  
    input[type="checkbox"]:checked + .custom-checkbox.umbro {
      background-color: var(--theme-white);
    }
  
    input[type="checkbox"]:checked + .custom-checkbox.fila {
      background-color: #758396;
    }
  
    input[type="checkbox"]:checked + .custom-checkbox.new_balance {
      background-color: #E5788B;
    }
  
    input[type="checkbox"]:checked + .custom-checkbox::after {
      color: var(--theme-color);
    }
    input[type="checkbox"]:checked + .custom-checkbox::after {
      display: block;
    }
  
  
  .warning-text {
    display: flex;
    flex-direction: row;
    color: red;
    align-items: center;
    font-size: smaller;
  }
  
  .warning-icon {
    margin-right: 7px;
  }
  
  .dass-input-text input {
    outline: none !important;
  }
  
  .checkbox-icon {
    margin-right: 40%;
    @media (max-width: 768px) { 
      margin-right: 15%;
    }
  }
  
  .checkbox-icon.umbro {
    color: var(--theme-white)
  }
  
  .checkbox-icon.fila {
    color: #758396
  }
  
  .checkbox-icon.new_balance {
    color: #E5788B
  }
  .dass-balance-available {
   display: flex;
   flex-direction: column;
   align-items: center;
  }
  .dass-input-purchase-container {
    display: flex;
    justify-content: center;   
    width: 100%; 
  }
  #dass-input-purchase {
    width: 100% !important;
    padding-right: 15% !important;    
  }
  #dass-input-purchase:active {
    border: none !important;
  }
  .dass-button-call-purchase {
    position: relative;
    top: 14px;
    right: 12%;
    width: 40% !important;
    height: 100%; 
    padding: 10px 20px 10px 20px !important;  
    @media(max-width: 450px) {
      right: 18%;
    }
  } 
  .dass-button-call-purchase:disabled {
    opacity: 1 !important;
    background-color: var(--color-disabled-button-wallet) !important;    
  }
  .dass-modal-checkbox-umbro:checked + .custom-checkbox {
    background-color: var(--theme-white) !important;
    border-color: var(--color-default-umbro) !important;
  }
  .dass-modal-checkbox-fila:checked + .custom-checkbox {
    background-color: var(--color-fila-secondary) !important;
  }
  .dass-modal-checkbox-newbalance:checked + .custom-checkbox {
    background-color: var(--color-default-new-balance) !important;
  }
  small {
      color: red;
      margin-left: var(--space__0-5x);
  }
  </style>
  